/* © 2014 - Copyright of Aetonix Systems Inc - All Rights Reserved. Patent pending.
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Aetonix, June 19, 2014
 * For information or permission request, email info@aetonixsystems.com
 */

/**
 * This module is a wrapper around the 'bracelets.js' model.  It provides communication to all
 * bracelet owners
 */

var Model = require("../types/Model.js");

var ALERT_LENGTH = 10 * 1000; // 10 seconds
var BATTERY_INTEVAL = 10 * 60 * 1000; // 10 minutes

module.exports = new Model({
	name: "braceletevents",
	listeners: listeners,
	triggers: triggers,

	_serial: null,
});

function triggers() {
	return {
		"verify": trigger_verify,
		"configure": trigger_configure,
		"disconnect": trigger_disconnect,
		"alert:off": trigger_alert_off,
		"alert:on": trigger_alert_on,
		"alert:alert": trigger_alert,
		"read:battery": trigger_read_battery,
		"listen:notifications": trigger_listen_notifications,
		"listen:battery": trigger_listen_battery,
		"listen:stop:notifications": trigger_listen_notifications_stop,
		"listen:stop:battery": trigger_listen_battery_stop,

		"metawear:init": trigger_metawear_init,
		"metawear:listen": trigger_listen_metawear,
		"metawear:listen:stop": trigger_listen_metawear_stop,
		"metawear:stepcount:read": trigger_stepcount_read,
		"metawear:stepcount:init": trigger_stepcount_init,
	};
}

function listeners() {
	return {
		"machinetracker:updated": handleMachineTrackerUpdated,
		"bluetooth:event": handleEvent,
	};
}

function trigger_metawear_init(data){
	var device = data.bracelet;

	this.emit("bluetooth:trigger:write", {
		service: "METAWEAR_SERVICE",
		characteristic: "METAWEAR_WRITE_CHARACTERISTIC",
		value: "METAWEAR_INITIALIZE",
		device: device
	});
}

function trigger_listen_metawear(data){
	var device = data.bracelet;

	this.emit("bluetooth:trigger:listen", {
		service: "METAWEAR_SERVICE",
		characteristic: "METAWEAR_READ_CHARACTERISTIC",
		device: device
	});
}

function trigger_listen_metawear_stop(data) {
	var device = data.bracelet;

	this.emit("bluetooth:trigger:listen:stop", {
		service: "METAWEAR_SERVICE",
		characteristic: "METAWEAR_READ_CHARACTERISTIC",
		device: device
	});
}

function trigger_stepcount_init(data){
	var device = data.bracelet;

	this.emit("bluetooth:trigger:write", {
		service: "METAWEAR_SERVICE",
		characteristic: "METAWEAR_WRITE_CHARACTERISTIC",
		value: "METAWEAR_ACCELEROMETER_CONFIGURE",
		device: device
	});
	this.emit("bluetooth:trigger:write", {
		service: "METAWEAR_SERVICE",
		characteristic: "METAWEAR_WRITE_CHARACTERISTIC",
		value: "METAWEAR_ACCELEROMETER_START",
		device: device
	});
}

function trigger_stepcount_read(data) {
	var device = data.bracelet;
	this.emit("bluetooth:trigger:write", {
		service: "METAWEAR_SERVICE",
		characteristic: "METAWEAR_WRITE_CHARACTERISTIC",
		value: "METAWEAR_ACCELEROMETER_STEP_READ",
		device: device
	});
	this.emit("bluetooth:trigger:write", {
		service: "METAWEAR_SERVICE",
		characteristic: "METAWEAR_WRITE_CHARACTERISTIC",
		value: "MEATWEAR_ACCELEROMETER_STEP_RESET",
		device: device
	});
}

function handleEvent(event) {
	var mac = event.device;
	var cleanMac = hyphenateMac(mac);
	var characteristic = event.characteristic;
	var data = event.data;

	var serial = this._serial;

	// First portion deals with button presses
	if (characteristic === "DETECTION_NOTIFICATION") {
		var state = data[0];
		if (!state) {
			this.emit("$mqtt:bracelet/" + cleanMac + "/released", {
				machine: serial
			});
		} else if (state === 1) {
			this.emit("$mqtt:bracelet/" + cleanMac + "/pressed", {
				machine: serial
			});
		} else if (state === 4) {
			this.emit("$mqtt:bracelet/" + cleanMac + "/fallen", {
				machine: serial
			});
		}
	}
	// This portion deals with battery level, message consumed by '/ownbracelet.js'
	if (characteristic === "BATTERY_LEVEL") {
		var level = data[0];
		this.emit("$mqtt:bracelet/" + cleanMac + "/battery", {
			machine: serial,
			battery: level
		});
	}

	if (characteristic === "METAWEAR_READ_CHARACTERISTIC") {
		// Check if this event is for step count results
		// All metawear events use the same characteristic
		if (data[0] === 0x03 && data[1] === 0x9A) {
			// Convert two bytes to single integer
			var steps = data[2] + (data[3] * 0x0100);
			this.emit("$mqtt:bracelet/" + cleanMac + "/steps/result", {
				machine: serial,
				steps: steps
			});
		}
	}
}

function handleMachineTrackerUpdated(data) {
	this._serial = data.serial;
}

function trigger_verify(data) {
	var device = data.bracelet;
	this.emit("bluetooth:trigger:write", {
		service: "VBUTTON_SERVICE",
		characteristic: "VERIFICATION",
		value: "VERIFICATION_KEY",
		device: device
	});
}

function trigger_configure(data) {
	var device = data.bracelet;

	//configure bracelet beeper
	this.emit("bluetooth:trigger:write", {
		service: "VBUTTON_SERVICE",
		characteristic: "STEALTH_MODE",
		value: "STEALTH_MODE_QUIET",
		device: device
	});

	//configure detection mode
	this.emit("bluetooth:trigger:write", {
		service: "VBUTTON_SERVICE",
		characteristic: "DETECTION_MODE_CONFIG",
		value: "DETECTION_MODE_PRESS_FALL",
		device: device
	});
}

function trigger_disconnect(data) {
	var device = data.bracelet;
	this.emit("bluetooth:trigger:disconnect", {
		mac: device
	});
}


function trigger_alert(data) {
	trigger_alert_on.call(this, data);
	setTimeout(trigger_alert_off.bind(this, data), ALERT_LENGTH);
}

function trigger_alert_off(data) {
	var device = data.bracelet;
	this.emit("bluetooth:trigger:write", {
		service: "VBUTTON_SERVICE",
		characteristic: "URGENT_ALERT",
		value: "URGENT_ALERT_OFF",
		device: device
	});
}

function trigger_alert_on(data) {
	var device = data.bracelet;
	this.emit("bluetooth:trigger:write", {
		service: "VBUTTON_SERVICE",
		characteristic: "URGENT_ALERT",
		value: "URGENT_ALERT_ON",
		device: device
	});
}

function trigger_listen_notifications(data) {
	var device = data.bracelet;
	this.emit("bluetooth:trigger:listen", {
		service: "VBUTTON_SERVICE",
		characteristic: "DETECTION_NOTIFICATION",
		device: device
	});
}

function trigger_listen_notifications_stop(data) {
	var device = data.bracelet;
	this.emit("bluetooth:trigger:listen:stop", {
		service: "VBUTTON_SERVICE",
		characteristic: "DETECTION_NOTIFICATION",
		device: device
	});
}

function trigger_listen_battery(data) {
	var device = data.bracelet;
	this.emit("bluetooth:trigger:poll", {
		service: "BATTERY_SERVICE",
		characteristic: "BATTERY_LEVEL",
		device: device,
		time: BATTERY_INTEVAL
	});
}

function trigger_listen_battery_stop(data) {
	var device = data.bracelet;
	this.emit("bluetooth:trigger:poll:stop", {
		service: "BATTERY_SERVICE",
		characteristic: "BATTERY_LEVEL",
		device: device
	});
}

function trigger_read_battery(data) {
	var device = data.bracelet;
	this.emit("bluetooth:trigger:read", {
		service: "BATTERY_SERVICE",
		characteristic: "BATTERY_LEVEL",
		device: device
	});
}

function hyphenateMac(mac) {
	var cleanMac = mac.replace(/:/g, "-");
	return cleanMac;
}
